import axios from 'axios';
import {
  cleanLocalStorage,
  encodeQueryData,
  errorToast,
  getDeviceToken,
  getJWTToken,
  getLocalStorageItem,
  setLocalStorageItem
} from '../utils/helper';
import { API_BASE_URL } from '../core/env.configs';
import { Api } from '.';

const BASE_URL = API_BASE_URL || 'https://staging-api.shoorah.io/';

// Helper function to get current B2B/Fans mode - called once per request cycle
const getB2BFansMode = () => {
  return JSON.parse(getLocalStorageItem('isB2BFansMode')) || false;
};

const GetApi = async (tag = '', isHeader = false) => {
  try {
    const data = await axios.get(BASE_URL + 'company/v1' + tag, {
      headers: isHeader
        ? {
            Authorization: getJWTToken()
            // deviceToken: getLocalStorageItem('deviceToken'),
            // deviceType: 3
          }
        : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

// const GetApiWithPayload = async (tag = '', reqBody, isHeader = false) => {

//     return axios.get(BASE_URL + 'company/v1' + tag, reqBody,{
//       headers: isHeader
//         ? {
//           Authorization: getJWTToken()
//           // deviceToken: getLocalStorageItem('deviceToken'),
//           // deviceType: 3
//         }
//         : {}
//     }).then((data) => {
//       return data;
//     }).catch(async (e) => {
//       ErrorHandler(e);
//     });

// };

const PostApi = async (tag = '', reqBody, isHeader = false, flag = false) => {
  let flagCheck = flag
    ? 'multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA'
    : 'application/json';

  return axios
    .post(BASE_URL + 'company/v1' + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: flagCheck,
            Authorization: getJWTToken()
            // deviceToken: getLocalStorageItem('deviceToken'),
            // deviceType: 3,
          }
        : {}
    })
    .then((data) => {
      return data;
    })
    .catch(async (e) => {
      ErrorHandler(e);
    });
};

const PostApiBlob = async (tag = '', reqBody) => {
  return axios
    .post(BASE_URL + 'company/v1' + tag, reqBody, {
      headers: {
        deviceType: 3,
        Authorization: getJWTToken()
      },
      responseType: 'blob'
    })
    .then((res) => {
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = reqBody.graphName; // Specify the filename
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(async (e) => {
      ErrorHandler(e);
    });
};

const DeleteApi = async (tag = '', isHeader = false) => {
  return axios
    .delete(BASE_URL + 'company/v1' + tag, {
      headers: isHeader
        ? {
            'Content-Type': 'application/json',
            accept: 'application/json',
            Authorization: getJWTToken(),
            deviceToken: getDeviceToken()
          }
        : {}
    })
    .then((data) => {
      return data;
    })
    .catch(async (e) => {
      ErrorHandler(e);
    });
};

const PutApi = async (tag = '', reqBody, isHeader = false, flag = false) => {
  let flagCheck = flag
    ? 'multipart/form-data; boundary=----WebKitFormBoundaryueI4YvrqiXxUgVGA'
    : 'application/json';

  try {
    const data = await axios.put(BASE_URL + 'company/v1' + tag, reqBody, {
      headers: isHeader
        ? {
            'Content-Type': flagCheck,
            accept: flagCheck,
            Authorization: getJWTToken()
          }
        : {}
    });
    return data;
  } catch (e) {
    console.log('🚀 ~ PutApi ~ e:', e);
    ErrorHandler(e);
  }
};

const PatchApi = async (tag = '', reqBody, isHeader, isJSON = false) => {
  const contentType = {
    'Content-Type': 'application/json'
  };
  const headers = {
    accept: 'application/json',
    Authorization: getJWTToken(),
    ...(isJSON ? contentType : {})
  };
  try {
    const data = await axios.patch(BASE_URL + 'company/v1' + tag, reqBody !== null && reqBody, {
      headers: isHeader ? headers : {}
    });
    return data;
  } catch (e) {
    ErrorHandler(e);
  }
};

const ErrorHandler = async (e) => {
  if (e.response?.data?.message) {
    if (e.response?.data?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      if (e.response?.data?.message === 'tutorialNotFound') {
        errorToast('Tutorial not found');
      } else {
        errorToast(e.response?.data?.message);
      }
    }
  } else if (e.response?.data) {
    if (e.response?.data?.meta?.code === 498) {
      RefreshToken();
    } else if (e.response?.data?.code === 401) {
      errorToast(e.response?.data?.message);
      cleanLocalStorage();
      window.location.href = '/login';
    } else {
      errorToast(e.response?.data?.meta?.message);
    }
  } else {
    errorToast('Something went wrong');
  }
};

const RefreshToken = async () => {
  await axios
    .post(
      `${BASE_URL}company/v1/refresh-token`,
      {},
      { headers: { 'refresh-token': getLocalStorageItem('refreshToken') } }
    )
    .then(async (response) => {
      if (response.data.meta.code === 1) {
        setLocalStorageItem('token', response.data.meta.token);
        window.location.reload();
      }
    })
    .catch(async (error) => {
      if (error.response.data.code === 401) {
        await Api.logoutUser();
        cleanLocalStorage();
        window.location.href = '/login';
      } else {
        cleanLocalStorage();
        window.location.href = '/login';
      }
    });
};

export const CompanyApi = {
  getSurveyCategoryCompany: () => GetApi('/survey/category', true),
  createSurveyCompany: (reqBody) => PostApi('/survey', reqBody, true, false),
  editSurveyCompany: (reqBody) => PutApi('/survey', reqBody, true, false),
  getAdminListCompany: (userType) =>
    GetApi(`/admins?userType=${userType}&accountStatus=1&page=1&perPage=10`, true),
  surveyApproval: (reqBody) => PostApi('/survey/approval', reqBody, true),

  //  ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  addCompanyUser: (data) => PostApi('/addUser', data, true),
  deleteUser: (id) => DeleteApi(`/delete-user?id=${id}`, true),
  getComanyUser: (id) => GetApi(`/company-user/${id}`, true),
  updateCompanyUser: (id, data) => PutApi(`/user-update/${id}`, data, true),
  getCompanyUser: (
    page,
    perPage,
    searchKey,
    sortBy = 'createdAt',
    sortOrder = -1,
    filters = {}
  ) => {
    const isFansMode = getB2BFansMode();
    const params = new URLSearchParams({
      page: String(page),
      perPage: String(perPage),
      searchKey: searchKey || '',
      sortBy: sortBy || 'createdAt',
      sortOrder: String(sortOrder),
      isFansMode: String(isFansMode)
    });

    if (filters?.gender !== undefined && filters?.gender !== '') {
      params.set('gender', String(filters.gender));
    }
    if (filters?.userActivity !== undefined && filters?.userActivity !== '') {
      params.set('userActivity', String(filters.userActivity));
    }
    if (filters?.department !== undefined && filters?.department !== '') {
      params.set('department', String(filters.department));
    }
    if (filters?.ethnicity !== undefined && filters?.ethnicity !== '') {
      params.set('ethnicity', String(filters.ethnicity));
    }
    if (filters?.lastLoginFrom !== undefined && filters?.lastLoginFrom !== '') {
      params.set('lastLoginFrom', String(filters.lastLoginFrom));
    }
    if (filters?.lastLoginTo !== undefined && filters?.lastLoginTo !== '') {
      params.set('lastLoginTo', String(filters.lastLoginTo));
    }
    if (filters?.registeredFrom !== undefined && filters?.registeredFrom !== '') {
      params.set('registeredFrom', String(filters.registeredFrom));
    }
    if (filters?.registeredTo !== undefined && filters?.registeredTo !== '') {
      params.set('registeredTo', String(filters.registeredTo));
    }
    if (filters?.id) {
      params.set('id', String(filters.id));
    }

    return GetApi(`/users?${params.toString()}`, true);
  },
  // Members Mode is passed in, not read from storage, so the dashboard keeps counting employees
  getUserStatistics: (isFansMode = false) =>
    GetApi(`/users-statistics?isFansMode=${isFansMode}`, true),
  exportCompanyUsers: (searchKey, sortBy = 'createdAt', sortOrder = -1) => {
    const isFansMode = getB2BFansMode();
    return GetApi(
      `/export-users?searchKey=${searchKey}&sortBy=${sortBy}&sortOrder=${sortOrder}&isFansMode=${isFansMode}`,
      true
    );
  },
  importMultiUser: (file) => PostApi('/addmultyUser', file, true, true),
  resendWelcomeEmail: () => PostApi('/resend-welcome-email', {}, true),
  getPersonalMoodsGraphData: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    dataType,
    companyId
  ) =>
    GetApi(
      `/dashboard/personal-moods?startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&dataType=${dataType}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),
  getFilterData: (companyId) =>
    GetApi(`/filter-user-data${companyId ? '?company_id=' + companyId : ''}`, true),
  getProfessionalMoodsGraphData: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    dataType,
    companyId
  ) =>
    GetApi(
      `/dashboard/professional-moods?startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&dataType=${dataType}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),
  getOverallScore: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    emotionType,
    companyId,
    theraphyData
  ) =>
    GetApi(
      `/dashboard/mood/overall-score?startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&moodType=${emotionType}&theraphyData=${theraphyData}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),
  addSolutionData: (body) => {
    const isFansMode = getB2BFansMode();
    return PostApiBlob('/add-solution', { ...body, isFanMode: isFansMode }, true);
  },
  getUnreadNotificationCount: () => GetApi('/unread-notification', true),
  getSolutionByFilters: (
    startDate,
    endDate,
    minAge,
    maxAge,
    department,
    location,
    gender,
    dataType,
    emotionType,
    ethnicity,
    graphName
  ) =>
    GetApi(
      `/get-solution?startDate=${startDate}&endDate=${endDate}&minAge=${minAge}&maxAge=${maxAge}&department=${department}&location=${location}&gender=${gender}&dataType=${dataType}&emotionType=${emotionType}&ethnicity=${ethnicity}&graphName=${graphName}`,
      true
    ),
  getAllSolutions: (pageNumber, pageSize, searchKey) => {
    const isFansMode = getB2BFansMode();
    return GetApi(
      `/get-allsolution?pageNumber=${pageNumber}&pageSize=${pageSize}${
        searchKey ? `&searchKey=${searchKey}` : ''
      }&isFanMode=${isFansMode}`,
      true
    );
  },
  addReport: (body) => {
    const isFansMode = getB2BFansMode();
    return PostApi('/add-report', { ...body, isFanMode: isFansMode }, true);
  },
  getAllReports: (page, perPage, searchKey) => {
    const isFansMode = getB2BFansMode();
    return GetApi(
      `/get-allreports?page=${page}&perPage=${perPage}&searchKey=${searchKey}&isFanMode=${isFansMode}`,
      true
    );
  },
  getSingleReport: (id) => GetApi(`/get-report?id=${id}`, true),

  // ---- Dashboard report downloads (see api/companyReportApi.js) ----
  // The one-feature PDF is NOT here: it needs responseType 'blob', which these
  // helpers do not do, so companyReportApi calls axios directly for it.
  getReportOptions: () => GetApi('/reports/options', true),
  generateReport: (body) => PostApi('/reports/generate', body, true),
  getReportJobs: (page = 1, perPage = 10) =>
    GetApi(`/reports/jobs?page=${page}&perPage=${perPage}`, true),
  getReportJobLink: (id) => GetApi(`/reports/jobs/${id}/link`, true),
  deleteReportJob: (id) => DeleteApi(`/reports/jobs/${id}`, true),
  getB2BbadgesStatsByGender: (id, startDate, endDate, badges) =>
    GetApi(
      `/getB2BbadgesStatsByGender?companyId=${id}&startDate=${startDate}&endDate=${endDate}&badges=${badges}`,
      true
    ),
  getBadgesStats: (id, startDate, endDate, badges, gender) =>
    GetApi(
      `/getBadgesStats?companyId=${id}&startDate=${startDate}&endDate=${endDate}&badgeType=${badges}&gender=${gender}`,
      true
    ),

  getTotalBadges: (id, startDate, endDate) => GetApi(`/getTotalBadges?companyId=${id}`, true),

  // Headline badge stat cards for the logged-in company.
  getCompanyBadgeStats: () => GetApi(`/badges/stats`, true),

  // Employees of the logged-in company with their won-badge counts + badge list.
  getCompanyEmployeesBadges: (page = 1, keyword = '', limit = 10, department = '', gender = '') =>
    GetApi(
      `/badges/employees?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
        keyword
      )}&department=${encodeURIComponent(department)}&gender=${gender}`,
      true
    ),

  // A single employee's progress on a single badge.
  getUserBadgeProgress: (userId, badgeId) =>
    GetApi(`/badges/user-progress?userId=${userId}&badgeId=${badgeId}`, true),

  getShuruTheraphyData: (
    startDate,
    endDate,
    companyId,
    minAge,
    maxAge,
    department,
    location,
    gender,
    dataType,
    emotionType,
    ethnicity,
    graphName
  ) =>
    GetApi(
      `/shuru-theraphy-graph?startDate=${startDate}&endDate=${endDate}&companyId=${companyId}&minAge=${minAge}&maxAge=${maxAge}&department=${department}&location=${location}&gender=${gender}&dataType=${dataType}&emotionType=${emotionType}&ethnicity=${ethnicity}&graphName=${graphName}`
    ),

  // getSecondCompanyGraphData: (id, startDate, endDate) =>
  //   PostApi(`/match?company_id=${id}`, {}, true),

  getSecondCompanyGraphData: (id, startDate, endDate) => {
    return axios
      .post(
        `https://suru-therapy.shoorah.io/match?company_id=${id}${
          startDate || endDate ? `&startDate=${startDate}&endDate=${endDate}` : ''
        }`,
        {},
        {
          headers: true
            ? {
                'Content-Type': 'application/json',
                accept: 'application/json',
                deviceToken: getLocalStorageItem('deviceToken'),
                deviceType: 3,
                Authorization: getJWTToken()
              }
            : {}
        }
      )
      .then((data) => {
        return data;
      })
      .catch(async (e) => {
        ErrorHandler(e);
      });
  },

  // new b2b dashboard apis

  getB2BAdminList: (companyId) => GetApi(`/getB2BAdminList`, true),

  getNewInvoiceDetails: (invoiceId) => GetApi(`/wellpoints-purchase-history/${invoiceId}`, true),

  getB2BAllAdminList: () => GetApi(`/admin-list`, true),

  addB2BMood: (body) => PostApi('/addB2BMood', body, true),

  getActiveUsersAndTime: (params) =>
    GetApi(`/getActiveUsersAndTime?${encodeQueryData(params)}`, true),

  getRecentJoinedEmployees: (id) => GetApi(`/getRecentJoinedEmployees?companyId=${id}`, true),

  getEmployeeActivity: (id) => GetApi(`/getEmployeeActivity?companyId=${id}`, true),

  getTrendingContent: (id) => GetApi(`/getTrendingContent?companyId=${id}`, true),

  /**
   * Everything the rebuilt company dashboard's People band needs, in one call.
   * Company scoped by the token — deliberately takes no companyId.
   */
  getB2BDashboardSummary: () => GetApi('/dashboard/summary', true),

  getJournalContentUsage: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    emotionType,
    companyId
  ) =>
    GetApi(
      `/getJournalContentUsage?companyId=${companyId}&type=${1}&&startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&moodType=${emotionType}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),

  getB2BAdminMood: (id) => GetApi(`/getB2BAdminMood`, true),
  getB2BUsers: (id) => GetApi(`/getB2BUsers?company_id=${id}`, true),

  sendPraiseToUsers: (body) => PostApi('/sendPraiseToUsers', body, true),

  getSolutionTextFromOpenAi: (body) =>
    axios
      .post(BASE_URL + 'api/v1/openai', body, {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          deviceToken: getLocalStorageItem('deviceToken'),
          deviceType: 3,
          Authorization: getJWTToken()
        }
      })
      .then((data) => {
        return data;
      })
      .catch(async (e) => {
        ErrorHandler(e);
      }),

  getReport: (body) => {
    const isFansMode = getB2BFansMode();
    return PostApiBlob('/add-report', { ...body, isFanMode: isFansMode }, true);
  },

  getSosData: (body) => PostApi('/sos-clicks', body, true),

  getSosReport: (body) => PostApiBlob('/sos-report', body, true),

  //push notifications
  getAllNotifications: (type, page, perPage, searchKey, isFanNotification) =>
    GetApi(
      `/notification?page=${page}&perPage=${perPage}&searchKey=${searchKey}&notificationListType=${type}&isFanNotification=${isFanNotification}`,
      true
    ),
  addPushNotification: (reqBody) => PostApi('/notification', reqBody, true),
  deleteNotification: (notificationId, deleteType) =>
    DeleteApi(`/notification?deleteType=${deleteType}&notificationId=${notificationId}`, true),

  //Sub Admin Menu APIs
  getAdmins: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/admins?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
      true
    ),
  addEditAdmin: (reqBody) => PostApi('/admins', reqBody, true),
  deleteAdmin: (userId) => DeleteApi(`/admins?userId=${userId}`, true),

  getUserEmailList: (url, page, perPage, searchKey, isFanMode) =>
    GetApi(
      `/${url}?page=${page}&perPage=${perPage}&searchKey=${searchKey}&isFanMode=${isFanMode}`,
      true
    ),

  getBeforeSleepData: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    dataType,
    companyId
  ) =>
    GetApi(
      `/get-before-sleep-data?startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&dataType=${dataType}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),
  getAfterSleepData: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    dataType,
    companyId
  ) =>
    GetApi(
      `/get-after-sleep-data?startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&dataType=${dataType}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),

  addSleepReport: (body) => PostApiBlob('/add-sleep-report', body, true),
  addBreathworkReport: (body) => PostApiBlob('/add-breathwork-report', body, true),

  getCompanyStatus: (id) => GetApi(`/get-company-status?id=${id}`, true),

  getCompanyEmotionData: (timeRange) => {
    GetApi(`/get-user-emotions${timeRange}`, true);
  },

  getPaymentIntend: (reqBody) => PostApi(`/create-session`, reqBody, true),
  getPaymentSeatIntend: (reqBody) => PostApi('/create-seat-session', reqBody, true),
  /**
   * Per-user breathwork activity for the logged-in company.
   *
   * Company-side counterpart to admin/v1/breathwork-hub/users — scoped by the
   * JWT, so it takes no companyId and can only ever return this company's
   * employees.
   */
  getCompanyBreathworkUsers: (page = 1, perPage = 10, search = '', department = '') =>
    GetApi(
      `/breathwork-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
        search
      )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
      true
    ),

  getBreathworkInsights: (
    startDate,
    endDate,
    department,
    minAge,
    maxAge,
    country,
    ethnicity,
    gender,
    emotionType,
    companyId
  ) =>
    GetApi(
      `/breathwork-company-insights?companyId=${companyId}&type=${1}&&startDate=${startDate}&endDate=${endDate}&department=${department}&minAge=${minAge}&maxAge=${maxAge}&country=${country}&ethnicity=${ethnicity}&gender=${gender}&moodType=${emotionType}${
        companyId ? '&company_id=' + companyId : ''
      }`,
      true
    ),

  getCompanyBadgeDashboardState: () => GetApi('/b2b-badge-states', true),
  getB2BusersBadges: (page, searchTerm, startDate, recordsPerPage) =>
    GetApi(
      `/b2b-badges-users?page=${page}&keyword=${searchTerm}&startDate=${startDate}&perPage=${recordsPerPage}`,
      true
    ),

  getClientToken: (reqBody) => PostApi(`/get-client-token`, reqBody, true),
  getUserActivityStats: (startDate, endDate, companyId) =>
    GetApi(
      `/B2B-users-and-usage?company_id=${companyId}&startDate=${startDate}&endDate=${endDate}`,
      true
    ),

  resetAutoRenew: (reqBody) => PostApi('/reset-auto-renew', reqBody, true),
  addEditPulseSurveyB2b: (reqBody) => PostApi('/add-edit-b2b-survey', reqBody, true),
  addEditPulseSurveyCategoryB2b: (reqBody) => PostApi('/add-edit-b2b-categories', reqBody, true),
  getPulseSurveyCategoriesB2b: () => GetApi(`/get-b2b-categories`, true),
  getPulseSurveysB2b: (page, perPage, isDraft, isTemplate, surveyStatus, searchKey) =>
    GetApi(
      `/get-b2b-surveys?page=${page}&perPage=${perPage}&isDraft=${isDraft}&isTemplate=${isTemplate}&surveyStatus=${surveyStatus}&searchKey=${searchKey}`,
      true
    ),
  getPulseSurveyByIdB2b: (surveyId) => GetApi(`/get-b2b-survey-by-id?surveyId=${surveyId} `, true),
  getCleanseData: (type) => GetApi(`/overview?type=${type}`, true),
  deletePulseSurveyB2b: (id) => DeleteApi(`/delete-b2b-survey?surveyId=${id}`, true),
  getAssessmentMatrics: () => GetApi('/self-assessment/metrics', true),
  getContentApprovalListB2b: (page, perPage, searchKey, filterQuery, sortBy, sortOrder, id) =>
    GetApi(
      `/b2b-content-approval?id=${
        id ? id : ''
      }&page=${page}&perPage=${perPage}&searchKey=${searchKey}${filterQuery}&sortBy=${sortBy}&sortOrder=${sortOrder}&isFanMode=${
        JSON.parse(getLocalStorageItem('isB2BFansMode')) || false
      }`,
      true
    ),
  updateApproval: (reqBody) => PutApi('/content-approval', reqBody, true),
  subAdminIsDraftB2b: (page, perPage, isDraft, isTemplate, surveyStatus, searchKey) =>
    GetApi(
      `/get-b2b-surveys?page=${page}&perPage=${perPage}&isDraft=${true}&isTemplate=${isTemplate}&surveyStatus=${surveyStatus}&searchKey=${searchKey}`,
      true
    ),
  getTemplates: () => GetApi(`/b2b-templates-survey`, true),

  getAllUsersEmotions: (queryString) => GetApi(`/get-user-emotions${queryString}`, true),
  getUserEmotion: (queryString) => GetApi(`/get-b2b-user-emotions${queryString}`, true),
  submitApprovalB2b: (reqBody) => {
    return PostApi('/b2b-survey-approval', reqBody, true);
  },

  // Get B2B free trial data
  getB2bFreeTrailData: (cmsAlias) => GetApi(`/cms?cmsAlias=${cmsAlias}`, true),
  getInfoData: (name) => GetApi(`/tutorial?featureID=${name}`, true),

  // Wellpoints
  getWellpointBalance: () => GetApi('/check-balance', true),
  stripePaymentIntent: (reqBody) => {
    return PostApi('/wellpoints-payment-intent', reqBody, true);
  },
  buyNowWellpoints: (reqBody) => {
    return PostApi('/purchase-wellpoints', reqBody, true);
  },
  getWellpointsPurchaseHistory: (page, perPage, filterQuery) =>
    GetApi(`/wellpoints-purchase-history?page=${page}&limit=${perPage}${filterQuery}`, true),
  saveInvoiceDetails: (reqBody) => {
    return PostApi('/buy-order-invoice-wellpoints', reqBody, true);
  },
  getInvoiceDetails: () => GetApi('/get-invoice-details', true),
  orderNowWellpoints: (reqBody) => {
    return PostApi('/buy-order-invoice-wellpoints', reqBody, true);
  },
  getUserList: (page = '', perPage = '', search = '', team = '') =>
    GetApi(`/get-user-list?page=${page}&limit=${perPage}&search=${search}&team=${team}`, true),
  transferWellpointIndividualAmount: (reqBody) => {
    return PostApi('/transfer-wellpoints-individual', reqBody, true);
  },
  transferWellpointEqualAmount: (reqBody) => {
    return PostApi('/transfer-wellpoints-equal', reqBody, true);
  },
  getCompanyDepartments: (companyId) => GetApi(`/filter-user-data?company_id=${companyId}`, true),
  getTransactionHistory: (page, perPage, filterQuery) =>
    GetApi(`/get-transaction-history?page=${page}&limit=${perPage}${filterQuery}`, true),

  getWellpointManageRequest: (page, perPage, filterQuery) =>
    GetApi(`/get-manage-request?page=${page}&limit=${perPage}${filterQuery}`, true),
  updateWellpointQuantity: (reqBody) => PutApi('/update-wellpoint-quantity', reqBody, true),
  updateManageRequestStatus: (reqBody) => PutApi('/update-manage-request-status', reqBody, true),
  toggleAutoWithdraw: (reqBody) => PutApi('/toggle-auto-drawn', reqBody, true),
  getAutoWithdraw: (id) => GetApi(`/get-auto-drawn?id=${id}`, true),
  saveAutoWithdraw: (reqBody) => PutApi('/auto-drawn', reqBody, true),
  toggleTopUpRequest: (reqBody) => PutApi('/toggle-manage-request', reqBody, true),
  getTopUpRequest: () => GetApi('/get-manage-request-toggle', true),
  getPeapDashboard: () => GetApi('/peap-dashboard', true),
  getWellBankDashboard: () => GetApi('/wellbank-dashboard', true),

  // Instant Support
  getInstantSupportList: (pageNumber, pageSize, companyId) =>
    GetApi(
      `/instantSupport/?pageNumber=${pageNumber}&pageSize=${pageSize}&companyId=${companyId}`,
      true
    ),
  getInstantSupportStripLink: (reqBody) =>
    PostApi(
      `/instantSupport/booking-instant-plan`,
      // instantSupport/booking-instant-plan
      reqBody,
      true
    ),
  getInstantSupportAddUsersList: (companyId) =>
    GetApi(`/instantSupport/user-list?companyId=${companyId}`, true),
  postInstnatSupportUserStatus: (reqBody) =>
    PostApi(
      `/instantSupport/changeInstantPlanStatus`,
      // /instantSupport/changeInstantPlanStatus
      // /instantSupport/activate-deactivate
      reqBody,
      true
    ),
  postInstantSupportAddUsers: (reqBody) => PostApi(`/instantSupport/add-users`, reqBody, true),
  postInstantSupportUpgradeUsers: (reqBody) =>
    PostApi(`/instantSupport/upgrade-user`, reqBody, true),
  postInstantSupportAddCustomNumber: (reqBody) =>
    PostApi(`/instantSupport/addCustomNumber`, reqBody, true),
  getInstantSupportCompanyStatus: (companyId) =>
    GetApi(`/instantSupport/getInstantPlanStatus?companyID=${companyId}`, true),
  postInstantSupportUpgradePlan: (reqBody) =>
    PostApi(`/instantSupport/updateInstantsupportPlan`, reqBody, true),
  postUpdateUserAndInstantsupportPlan: (reqBody) =>
    PostApi('/instantSupport/updateUserAndInstantsupportPlan', reqBody, true),
  getInstantSupportInights: (companyId) =>
    // /instantSupport/insights?companyID=678f327a6e509d84980488c9
    GetApi(`/instantSupport/insights?companyID=${companyId}`, true),

  getCustomNumber: (companyId) =>
    GetApi(`/instantSupport/getCustomNumber?companyId=${companyId}`, true),
  updateCustomNumber: (reqBody) =>
    PutApi(`/instantSupport/updateCustomNumber`, reqBody, true, true),
  // deleteCustomNumber: (reqBody) => PostApi(`/instantSupport/deleteCustomNumber`, reqBody, true),
  addCustomNumber: (reqBody) => PostApi(`/instantSupport/addCustomNumber`, reqBody, true, true),

  // ----------------------------------------------DEPARTMENT ------------------------------
  addDepartment: (data) => PostApi('/add-department', data, true),
  getCompanyDepartmentList: (companyId) => GetApi(`/get-departments/${companyId}`, true),
  deleteCompanyDepartmentList: (id) => DeleteApi(`/delete-departments/${id}`, true),

  // -------------------------------------challenges---------------

  getChallenges: (startDate, search) => {
    const isFansMode = getB2BFansMode();
    const url = `/challenge/stats?startDate=${startDate ? startDate : ''}&search=${
      search ? search : ''
    }&isFanMode=${isFansMode}`;
    return GetApi(url, true);
  },
  getListChallenges: (status, page, perPage, search, startDate, isExpire, isActive) => {
    const isFansMode = getB2BFansMode();
    return GetApi(
      `/challenge/challenges?status=${status}&page=${page ? page : ''}&limit=${
        perPage ? perPage : ''
      }&search=${search ? search : ''}&startDate=${startDate ? startDate : ''}&isExpire=${
        isExpire ? isExpire : false
      }&isActive=${isActive ? isActive : false}&isFanMode=${isFansMode}`,
      true
    );
  },
  getSpecificChallenges: (id) => GetApi(`/challenge/${id}`, true),
  addChallengesDeyails: (reqBody) =>
    PostApi('/challenge/createOrUpdateChallenge', reqBody, true, true),
  addChallengesTask: (reqBody) => PostApi('/challenge/createOrUpdateTasks', reqBody, true, false),
  addChallengesReward: (reqBody) => PostApi('/challenge/createOrUpdateReward', reqBody, true, true),
  getChallengesReward: (id) => GetApi(`/challenge/${id}/rewards`, true),
  updateChallengesStatus: (reqBody, id) => PatchApi(`/challenge/${id}/status`, reqBody, true),
  getWinnersList: (id) => GetApi(`/challenge/${id}/winners`, true),
  addRandomWinner: (reqBody, id) =>
    PostApi(`/challenge/${id}/select-winners`, reqBody, true, false),
  addManualSelectWinners: (reqBody, id) =>
    PostApi(`/challenge/${id}/manual-select-winners`, reqBody, true, false),
  sendEmailWinners: (reqBody, id) =>
    PostApi(`/challenge/${id}/send-winner-email`, reqBody, true, false),
  getDepartmentList: (id) => GetApi(`/get-departments/${id}`, true),
  convertChallengesFromTemplate: (reqBody) => {
    const isFansMode = getB2BFansMode();
    const bodyWithFanMode = { ...reqBody, isFanMode: isFansMode };
    return PostApi(`/challenge/createChallenges`, bodyWithFanMode, true, false);
  },

  getUserChallengeSummary: (userId, challengeId) => {
    return GetApi(`/challenge/${challengeId}/user/${userId}/b2b-summary`, true);
  },
  getChallengeSummary: (challengeId) => {
    return GetApi(`/challenge/${challengeId}/b2b-summary`, true);
  },
  getChallengeParticipants: (challengeId, page, limit, search) => {
    return GetApi(
      `/challenge/${challengeId}/b2b-users?page=${page}&limit=${limit}&search=${search}`,
      true
    );
  },
  // -------------------Shoorah Health Videos ----------------------------------
  getGuidancesList: (page, perPage, searchKey, categoryId, createdAt) =>
    GetApi(
      `/guidance/list?page=${page}&perPage=${perPage}&searchKey=${
        searchKey ? searchKey : ''
      }&categoryId=${categoryId ? categoryId : ''}&createdAt=${createdAt ? createdAt : ''}`,
      true
    ),
  getSpecificGuidance: (id) => GetApi(`/guidance?id=${id}`, true),

  //------------------Shoorah Benefits -------------------------------

  addCustomPlansBenefits: (reqBody) => PostApi(`/add-benefits`, reqBody, true, false),
  viewCustomPlansBenefits: () => GetApi('/benefit', true),

  resentCredUsers: (reqBody) => PostApi(`/resend-creds`, reqBody, true),

  // members login
  authMembers: (reqBody) => PostApi(`/auth-members`, reqBody, true),

  // millwall member creation
  addMillwallMember: (reqBody) => PostApi(`/b2bMembers/millwall`, reqBody, true),

  // millwall member creation
  updateMillwallMember: (id, reqBody) => PutApi(`/b2bMembers/millwall/${id}`, reqBody, true),

  // ===================================== Salary Sacrifice =====================================

  // Get all salary sacrifice schemes for the company
  getSalarySacrificeSchemes: (page, limit, searchKey, schemeType, status, benefitCategory) =>
    GetApi(
      `/salary-sacrifice/schemes?page=${page || 1}&limit=${limit || 10}${
        searchKey ? `&searchKey=${searchKey}` : ''
      }${schemeType ? `&schemeType=${schemeType}` : ''}${status ? `&status=${status}` : ''}${
        benefitCategory ? `&benefitCategory=${benefitCategory}` : ''
      }`,
      true
    ),

  // Get scheme by ID
  getSalarySacrificeSchemeById: (schemeId) => GetApi(`/salary-sacrifice/scheme/${schemeId}`, true),

  // Create or update a salary sacrifice scheme
  createOrUpdateSalarySacrificeScheme: (reqBody, schemeId = null) => {
    if (schemeId) {
      // return PutApi(`/salary-sacrifice/scheme/${schemeId}`, reqBody, true, false);
      reqBody.id = schemeId;
    }

    return PostApi('/salary-sacrifice/scheme', reqBody, true, false);
  },
  getSalarySacSchemeForCompany: (companyId) =>
    GetApi(`/salary-sacrifice/schemes/?companyId=${companyId}`, true),

  // Delete a salary sacrifice scheme
  deleteSalarySacrificeScheme: (schemeId) =>
    PatchApi(`/salary-sacrifice/scheme/delete?schemeId=${schemeId}`, {}, true),

  // Get enrollments for the company
  getSalarySacrificeEnrollments: (page, limit, searchKey, enrollmentStatus, schemeId) =>
    GetApi(
      `/salary-sacrifice/enrolled-users?page=${page || 1}&limit=${limit || 10}${
        searchKey ? `&searchKey=${searchKey}` : ''
      }${enrollmentStatus ? `&enrollmentStatus=${enrollmentStatus}` : ''}${
        schemeId ? `&schemeId=${schemeId}` : ''
      }`,
      true
    ),
  getShoorahSalarySacrifice: () => GetApi(`/salary-sacrifice/fetch-scheme-list`, true),
  // Update enrollment status
  updateSalarySacrificeEnrollmentStatus: (enrollmentId, reqBody) =>
    PatchApi(`/salary-sacrifice/enrollment/${enrollmentId}/status`, reqBody, true, true),

  // Get eligible users for a scheme
  getSalarySacrificeEligibleUsers: (searchKey) =>
    GetApi(`/salary-sacrifice/company-users?searchKey=${searchKey}`, true),
  getHealthSchemeEligibleUsers: (searchKey) =>
    GetApi(`/health-scheme/company-users?searchKey=${searchKey}`, true),

  // Get salary sacrifice dashboard statistics
  getSalarySacrificeStats: () => GetApi('/salary-sacrifice/stats', true),

  enrollUsersInSalarySacrifice: (reqBody) =>
    PostApi('/salary-sacrifice/scheme/enroll-users', reqBody, true, false),
  getSalarySacrificeIcons: () => GetApi(`/salary-sacrifice/fetch-icon-list`, true),

  // ===================================== Health Scheme =====================================

  // Get company's health scheme
  getHealthScheme: (companyId) => GetApi(`/health-scheme/scheme?companyId=${companyId}`, true),

  // Get Shoorah health schemes
  getShoorahHealthScheme: () => GetApi('/health-scheme/get-health-scheme-list', true),

  // Create or update health scheme
  addEditHealthScheme: (reqBody) => PostApi('/health-scheme/scheme', reqBody, true, false),

  // Toggle health scheme visibility
  toggleHealthSchemeVisibility: (reqBody) =>
    PutApi('/health-scheme/scheme/visibility', reqBody, true, false),
  // Get enrollments for the company
  getHealthSchemeEnrollments: (page, limit, searchKey, enrollmentStatus, schemeId) =>
    GetApi(
      `/health-scheme/enrolled-users?page=${page || 1}&limit=${limit || 10}${
        searchKey ? `&searchKey=${searchKey}` : ''
      }${enrollmentStatus ? `&enrollmentStatus=${enrollmentStatus}` : ''}${
        schemeId ? `&schemeId=${schemeId}` : ''
      }`,
      true
    ),
  enrollUsersInHealthScheme: (reqBody) =>
    PostApi('/health-scheme/scheme/enroll-users', reqBody, true, false),
  deleteHealthScheme: (schemeId) =>
    PatchApi(`/health-scheme/scheme/delete?schemeId=${schemeId}`, {}, true),

  // ===================================== Kids Stats =====================================
  getKidsStats: () => GetApi('/kids-stats', true),

  // ===================================== Wearable Data Stats =====================================
  getWearableDataStats: () => GetApi('/wearable-data-stats', true),
  getSleepTrends: (duration = 'weekly') => GetApi(`/sleep-trends?duration=${duration}`, true),
  getHeartRateTrends: (duration = 'weekly') =>
    GetApi(`/heart-rate-trends?duration=${duration}`, true),
  getStepsTrends: (duration = 'weekly') => GetApi(`/steps-trends?duration=${duration}`, true),

  getUserHealthSummary: (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    return GetApi(`/user-health-summary?${queryParams}`, true);
  },

  // ===================================== Voucherline/Marketplace =====================================
  getVoucherlineProducts: (category, page = 1, perPage = 12) =>
    GetApi(
      `/voucherline/products?category=${category}&page=${page}&perPage=${perPage}&productSource=all`,
      true
    ),

  getVoucherlineProductById: (productId) => GetApi(`/voucherline/products/${productId}`, true),

  sendCompanyVoucher: (orderData) => PostApi('/voucherline/send-company-voucher', orderData, true),

  getCompanyOrders: (page = 1, limit = 10) =>
    GetApi(`/voucherline/products-by-company?page=${page}&limit=${limit}`, true),

  // ===================================== Shoutouts/Employee Recognition =====================================
  sendShoutout: (shoutoutData) => PostApi('/shoutout', shoutoutData, true, true),

  getAllShoutouts: (filterType = 'All', page = 1, limit = 10, filters = {}) => {
    let queryParams = `filterType=${filterType}&page=${page}&limit=${limit}`;
    if (filters.visibility) queryParams += `&visibility=${filters.visibility}`;
    if (filters.behaviour) queryParams += `&behaviour=${filters.behaviour}`;
    return GetApi(`/shoutout?${queryParams}`, true);
  },

  getReceivedShoutouts: (page = 1, limit = 10) =>
    GetApi(`/shoutout?filterType=Received&page=${page}&limit=${limit}`, true),

  getSentShoutouts: (page = 1, limit = 10) =>
    GetApi(`/shoutout?filterType=Sent&page=${page}&limit=${limit}`, true),

  getShoutoutById: (shoutoutId) => GetApi(`/shoutout/${shoutoutId}`, true),

  addShoutoutReaction: (shoutoutId, reactionData) =>
    PostApi(`/shoutout/${shoutoutId}/react`, reactionData, true),

  removeShoutoutReaction: (shoutoutId) => DeleteApi(`/shoutout/${shoutoutId}/react`, true),

  // ===================================== People Plan =====================================
  // Goals
  createGoal: (goalData) => PostApi('/people-plan/goal', goalData, true),

  updateGoal: (goalId, goalData) => PutApi(`/people-plan/goal/${goalId}`, goalData, true),

  deleteGoal: (goalId) => DeleteApi(`/people-plan/goal/${goalId}`, true),

  getAllGoals: (page = 1, limit = 10, filters = {}) => {
    let queryParams = `page=${page}&limit=${limit}`;
    if (filters.search) queryParams += `&search=${encodeURIComponent(filters.search)}`;
    if (filters.startDate) queryParams += `&startDate=${filters.startDate}`;
    if (filters.endDate) queryParams += `&endDate=${filters.endDate}`;
    if (filters.sortBy) queryParams += `&sortBy=${filters.sortBy}`;
    if (filters.sortOrder) queryParams += `&sortOrder=${filters.sortOrder}`;
    if (filters.scope) queryParams += `&scope=${filters.scope}`;
    return GetApi(`/people-plan/goal?${queryParams}`, true);
  },

  getGoalById: (goalId) => GetApi(`/people-plan/goal/${goalId}`, true),

  addGoalComment: (goalId, commentData) =>
    PostApi(`/people-plan/goal/${goalId}/comment`, commentData, true),

  toggleGoalChecklistItem: (goalId, checklistItemId) =>
    PutApi(`/people-plan/goal/${goalId}/checklist/${checklistItemId}/toggle`, {}, true),

  // Milestones
  createMilestone: (milestoneData) => PostApi('/people-plan/milestone', milestoneData, true),

  updateMilestone: (milestoneId, milestoneData) =>
    PutApi(`/people-plan/milestone/${milestoneId}`, milestoneData, true),

  deleteMilestone: (milestoneId) => DeleteApi(`/people-plan/milestone/${milestoneId}`, true),

  getAllMilestones: (page = 1, limit = 10, filters = {}) => {
    let queryParams = `page=${page}&limit=${limit}`;
    if (filters.search) queryParams += `&search=${encodeURIComponent(filters.search)}`;
    if (filters.startDate) queryParams += `&startDate=${filters.startDate}`;
    if (filters.endDate) queryParams += `&endDate=${filters.endDate}`;
    if (filters.sortBy) queryParams += `&sortBy=${filters.sortBy}`;
    if (filters.sortOrder) queryParams += `&sortOrder=${filters.sortOrder}`;
    if (filters.scope) queryParams += `&scope=${filters.scope}`;
    return GetApi(`/people-plan/milestone?${queryParams}`, true);
  },

  getMilestoneById: (milestoneId) => GetApi(`/people-plan/milestone/${milestoneId}`, true),

  toggleMilestoneChecklistItem: (milestoneId, checklistItemId) =>
    PutApi(`/people-plan/milestone/${milestoneId}/checklist/${checklistItemId}/toggle`, {}, true),

  addMilestoneComment: (milestoneId, commentData) =>
    PostApi(`/people-plan/milestone/${milestoneId}/comment`, commentData, true),

  // Owners (company admins + sub-admins, excluding the logged-in admin)
  getPeoplePlanOwners: (searchKey = '') =>
    GetApi(`/people-plan/owners?searchKey=${encodeURIComponent(searchKey)}`, true),

  // Document Hub
  createDocumentFolder: (folderData) => PostApi('/people-plan/folder', folderData, true),

  getAllDocumentFolders: (page = 1, limit = 10) =>
    GetApi(`/people-plan/folder?page=${page}&limit=${limit}`, true),

  getDocumentFolderById: (folderId) => GetApi(`/people-plan/folder/${folderId}`, true),

  uploadDocumentFile: (folderId, fileFormData, onUploadProgress) =>
    PostApi(`/people-plan/folder/${folderId}/file`, fileFormData, true, true, onUploadProgress),

  getDocumentFileById: (folderId, fileId) =>
    GetApi(`/people-plan/folder/${folderId}/file/${fileId}`, true),

  addDocumentFolderComment: (folderId, commentData) =>
    PostApi(`/people-plan/folder/${folderId}/comment`, commentData, true),

  // Key Dates
  getKeyDates: (year, month, page = 1, limit = 20, source = '') => {
    let queryParams = `year=${year}&month=${month}&page=${page}&limit=${limit}`;
    if (source) queryParams += `&source=${source}`;
    return GetApi(`/people-plan/key-dates?${queryParams}`, true);
  },

  // Date-driven, not month-driven: the next N key dates from today, crossing
  // month boundaries as needed.
  getUpcomingKeyDates: (limit = 2) =>
    GetApi(`/people-plan/key-dates/upcoming?limit=${limit}`, true),

  addCustomKeyDate: (keyDateData) => PostApi('/people-plan/key-dates/custom', keyDateData, true),

  updateKeyDate: (keyDateId, keyDateData) =>
    PutApi(`/people-plan/key-dates/${keyDateId}`, keyDateData, true),

  deleteKeyDate: (keyDateId) => DeleteApi(`/people-plan/key-dates/${keyDateId}`, true),

  toggleKeyDatesAi: (year, month, aiEnabled) =>
    PatchApi('/people-plan/key-dates/ai-toggle', { year, month, aiEnabled }, true),

  regenerateKeyDateAiSuggestion: (keyDateId) =>
    PostApi(`/people-plan/key-dates/${keyDateId}/ai-suggestion`, {}, true),

  // Road Maps
  createRoadMap: (roadMapData) => PostApi('/people-plan/roadmap', roadMapData, true),

  updateRoadMap: (roadMapId, roadMapData) =>
    PutApi(`/people-plan/roadmap/${roadMapId}`, roadMapData, true),

  markRoadMapAsCompleted: (roadMapId) =>
    PutApi(`/people-plan/roadmap/${roadMapId}/complete`, {}, true),

  markRoadMapAsIncomplete: (roadMapId) =>
    PutApi(`/people-plan/roadmap/${roadMapId}/incomplete`, {}, true),

  getAllRoadMaps: (page = 1, limit = 10, filters = {}) => {
    let queryParams = `page=${page}&limit=${limit}`;
    if (filters.isDraft !== undefined && filters.isDraft !== '') {
      queryParams += `&isDraft=${filters.isDraft}`;
    }
    if (filters.status) queryParams += `&status=${filters.status}`;
    if (filters.year) queryParams += `&year=${filters.year}`;
    if (filters.title) queryParams += `&title=${encodeURIComponent(filters.title)}`;
    return GetApi(`/people-plan/roadmap?${queryParams}`, true);
  },

  getRoadMapById: (roadMapId) => GetApi(`/people-plan/roadmap/${roadMapId}`, true),

  deleteRoadMap: (roadMapId) => DeleteApi(`/people-plan/roadmap/${roadMapId}`, true),

  // Road Map items (columns)
  addRoadMapItem: (roadMapId, itemData) =>
    PostApi(`/people-plan/roadmap/${roadMapId}/item`, itemData, true),

  updateRoadMapItem: (roadMapId, itemId, itemData) =>
    PutApi(`/people-plan/roadmap/${roadMapId}/item/${itemId}`, itemData, true),

  markRoadMapItemCompleted: (roadMapId, itemId) =>
    PutApi(`/people-plan/roadmap/${roadMapId}/item/${itemId}/complete`, {}, true),

  markAllRoadMapItemsCompleted: (roadMapId) =>
    PutApi(`/people-plan/roadmap/${roadMapId}/items/complete-all`, {}, true),

  deleteRoadMapItem: (roadMapId, itemId) =>
    DeleteApi(`/people-plan/roadmap/${roadMapId}/item/${itemId}`, true),

  // ROI Report
  createRoiReport: (roiReportData) => PostApi('/people-plan/roi-report', roiReportData, true),

  fetchRoiReport: () => GetApi('/people-plan/roi-report', true),

  // Dashboard & Reports
  // AI Suggestions — cached server-side, never generated per page view
  getPeoplePlanSuggestions: (context = 'overview') =>
    GetApi(`/people-plan/suggestions?context=${context}`, true),

  refreshPeoplePlanSuggestions: (context = 'overview') =>
    PostApi('/people-plan/suggestions/refresh', { context }, true),

  dismissPeoplePlanSuggestion: (suggestionId) =>
    PostApi(`/people-plan/suggestions/${suggestionId}/dismiss`, {}, true),

  getPeoplePlanOverview: (period = 'monthly', year, month) => {
    const queryParams = `period=${period}&year=${year}${month ? `&month=${month}` : ''}`;
    return GetApi(`/people-plan/dashboard/overview?${queryParams}`, true);
  },

  getPeoplePlanGoalCompletion: (period = 'monthly', year) =>
    GetApi(`/people-plan/dashboard/goal-completion?period=${period}&year=${year}`, true),

  getPeoplePlanEngagement: (period = 'monthly', year) =>
    GetApi(`/people-plan/dashboard/engagement?period=${period}&year=${year}`, true),

  getPeoplePlanWellbeingImpact: (period = 'monthly', year) =>
    GetApi(`/people-plan/dashboard/wellbeing-impact?period=${period}&year=${year}`, true),

  getPeoplePlanReports: (period = 'monthly', year, month) => {
    const queryParams = `period=${period}&year=${year}${month ? `&month=${month}` : ''}`;
    return GetApi(`/people-plan/reports?${queryParams}`, true);
  }
};

export const getCompanyLastPuffDashboard = () => {
  return GetApi('/lastpuff/dashboard', true).then((data) => {
    return data.data;
  });
};

export const getCompanyLastDrinkDashboard = () => {
  return GetApi('/lastdrink/dashboard', true).then((data) => {
    return data.data;
  });
};

export const getCompanyEliteAthleteStats = () => {
  return GetApi('/elite-athlete-stats', true).then((data) => {
    return data.data;
  });
};

// ===================== Sleep Hub (Company "Sleep" section) =====================
// Every call carries the current B2B/Members toggle so the backend scopes to
// employees (company_id) or members (member_company_id) accordingly.
export const getCompanySleepTrackerDashboard = () =>
  GetApi(`/sleep-hub/tracker-dashboard?isFansMode=${getB2BFansMode()}`, true);

export const getCompanySleepSoundsDashboard = () =>
  GetApi(`/sleep-hub/sounds-dashboard?isFansMode=${getB2BFansMode()}`, true);

export const getCompanySleepUsers = (page = 1, perPage = 10, search = '') =>
  GetApi(
    `/sleep-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanySleepUserDetail = (userId) => GetApi(`/sleep-hub/users/${userId}`, true);

// ================= Habit Tracker Hub (Company "Habits" section) =================
// Company/v1 counterparts to the admin habits-hub endpoints. Token-scoped to
// the company, so there is no companyId and no All/B2C/B2B scope — the
// B2B/Members toggle picks employees vs members, as it does for Sleep.
export const getCompanyHabitsDashboard = () =>
  GetApi(`/habits-hub/dashboard?isFansMode=${getB2BFansMode()}`, true);

export const getCompanyHabitsUsers = (page = 1, perPage = 10, search = '') =>
  GetApi(
    `/habits-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyHabitsUserDetail = (userId) => GetApi(`/habits-hub/users/${userId}`, true);

// ================ Breathwork Hub (Company "Breathwork" section) ================
// Company/v1 counterparts to the admin breathwork-hub endpoints. `department`
// is optional and narrows to one department when supplied.
export const getCompanyBreathworkSessionsDashboard = (department = '') =>
  GetApi(
    `/breathwork-hub/sessions-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyBreathworkAudioDashboard = (department = '') =>
  GetApi(
    `/breathwork-hub/sounds-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyBreathworkUserDetail = (userId) =>
  GetApi(`/breathwork-hub/users/${userId}`, true);

// ================ Pods Hub (Company "Shoorah Pods" section) ================
// Company/v1 pods-hub endpoints, scoped to the logged-in company by the JWT.
// `department` is optional and narrows to one department when supplied.
export const getCompanyPodsDashboard = (department = '') =>
  GetApi(
    `/pods-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyPodsUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/pods-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyPodsUserDetail = (userId) => GetApi(`/pods-hub/users/${userId}`, true);

// ============ Meditation Hub (Company "Meditation Sounds" section) ============
// Company/v1 meditation-hub endpoints, scoped to the logged-in company by the
// JWT. `department` is optional and narrows to one department when supplied.
export const getCompanyMeditationDashboard = (department = '') =>
  GetApi(
    `/meditation-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyMeditationUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/meditation-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyMeditationUserDetail = (userId) =>
  GetApi(`/meditation-hub/users/${userId}`, true);

// ============ Vids Hub (Company "Shoorah Videos" section) ============
// Company/v1 vids-hub endpoints covering both Health/NHS videos (Vimeo) and
// Shoorah Vids (uploaded), scoped to the logged-in company by the JWT.
// `department` is optional and narrows to one department when supplied.
export const getCompanyVidsDashboard = (department = '') =>
  GetApi(
    `/vids-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyVidsUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/vids-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyVidsUserDetail = (userId) => GetApi(`/vids-hub/users/${userId}`, true);

// ============ Shuru Hub (Company "Shuru" section) ============
// Company/v1 shuru-hub endpoints over the AI companion's conversation records,
// scoped to the logged-in company by the JWT.
// `department` is optional and narrows to one department when supplied.
export const getCompanyShuruDashboard = (department = '') =>
  GetApi(
    `/shuru-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyShuruUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/shuru-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyShuruUserDetail = (userId) => GetApi(`/shuru-hub/users/${userId}`, true);

// ============ Mood Hub (Company "Mood Tracking" section) ============
// Company/v1 mood-hub endpoints over the Mood Log check-in records (the
// emotion + context check-ins, NOT the legacy slider moods on the main
// dashboard), scoped to the logged-in company by the JWT.
// `department` is optional and narrows to one department when supplied.
export const getCompanyMoodDashboard = (department = '') =>
  GetApi(
    `/mood-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyMoodUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/mood-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyMoodUserDetail = (userId) => GetApi(`/mood-hub/users/${userId}`, true);

// ================ Self-Assessment Hub (Company "Self-Assessment" section) ================
// Questionnaire runs for this company's people — one row per person per
// assessment, written on the first answer and completed on the last, so the
// start-to-finish funnel is a real measurement.
// `department` is optional and narrows to one department when supplied.
export const getCompanySelfAssessmentDashboard = (department = '') =>
  GetApi(
    `/self-assessment-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanySelfAssessmentUsers = (
  page = 1,
  perPage = 10,
  search = '',
  department = ''
) =>
  GetApi(
    `/self-assessment-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanySelfAssessmentUserDetail = (userId) =>
  GetApi(`/self-assessment-hub/users/${userId}`, true);

// ================ Home Testing Hub (Company "Home Testing" section) ================
// Vitall kit orders for this company's people. Volume, stage and timing only —
// no biomarker results, no report files, no partner-held personal details.
// `department` is optional and narrows to one department when supplied.
export const getCompanyHomeTestingDashboard = (department = '') =>
  GetApi(
    `/home-testing-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyHomeTestingUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/home-testing-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyHomeTestingUserDetail = (userId) =>
  GetApi(`/home-testing-hub/users/${userId}`, true);

// ================ Vision Board Hub (Company "Vision Board" section) ================
// Board counts, sizes, reminders and the Shoorah ideas boards are built from.
// Never a board title, an item's words, a story, an image or a tag.
// `department` is optional and narrows to one department when supplied.
export const getCompanyVisionBoardDashboard = (department = '') =>
  GetApi(
    `/vision-board-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyVisionBoardUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/vision-board-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyVisionBoardUserDetail = (userId) =>
  GetApi(`/vision-board-hub/users/${userId}`, true);

// ================ Self Development Hub (Company "Self Development" section) ================
// The umbrella over Gratitude, Cleanse, Journal, Goals, Vision Board and
// Affirmations. Counts, statuses, dates and follow-through only — these
// endpoints never return a gratitude, a journal page, a thought record, a goal
// or an affirmation. The section's Vision Board tab calls the vision-board-hub
// endpoints above.
// `department` is optional and narrows to one department when supplied.
export const getCompanySelfDevelopmentDashboard = (department = '') =>
  GetApi(
    `/self-development-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// `tool` is one of gratitude | cleanse | journal | goals | affirmations.
export const getCompanySelfDevelopmentTool = (tool, department = '') =>
  GetApi(
    `/self-development-hub/tools/${encodeURIComponent(
      tool
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

export const getCompanySelfDevelopmentUsers = (
  page = 1,
  perPage = 10,
  search = '',
  department = ''
) =>
  GetApi(
    `/self-development-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanySelfDevelopmentUserDetail = (userId) =>
  GetApi(`/self-development-hub/users/${userId}`, true);

// ================ Scan Hub (Company "Scans" section) ================
// Skin, Teeth and Age scans. These endpoints return NO scan result — no skin
// score or risk level, no hygiene score or band, no facial age, no wellbeing
// reading, no image and no report link. Those went to the person who took the
// scan. What comes back is that a scan happened, when, whether they came back
// for another, and whether the analysis finished.
// `department` is optional and narrows to one department when supplied.
export const getCompanyScanDashboard = (department = '') =>
  GetApi(
    `/scan-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// `scan` is one of skin | teeth | age.
export const getCompanyScan = (scan, department = '') =>
  GetApi(
    `/scan-hub/scans/${encodeURIComponent(
      scan
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

export const getCompanyScanUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/scan-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyScanUserDetail = (userId) => GetApi(`/scan-hub/users/${userId}`, true);

// ============ Cessation Hub (Company "Quit Programmes" section) ============
// Last Puff and Last Drink. Aggregate only — there is deliberately no users
// endpoint here and no per-person one, because being enrolled in a quit
// programme is health information about an identifiable person. Cohorts under
// the backend's minimum come back as { suppressed: true } with no figures.
// `department` is optional and narrows to one department when supplied.
export const getCompanyCessationDashboard = (department = '') =>
  GetApi(
    `/cessation-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// `programme` is one of puff | drink.
export const getCompanyCessationProgramme = (programme, department = '') =>
  GetApi(
    `/cessation-hub/programmes/${encodeURIComponent(
      programme
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

// ============ Care Hub (Company "Care Programmes" + "Reproductive Health") ============
// Six clinical programmes across two sections. THERE IS NO USERS ENDPOINT HERE
// AND NONE SHOULD BE ADDED — appearing in such a list would disclose that a
// named employee is on GLP-1 medication, going through menopause, in fertility
// treatment or living with fibromyalgia. Every payload is a population figure,
// and the backend reads only ids and dates: no symptom, pain score, weight,
// medication, diagnosis, cycle or pregnancy field is ever aggregated, let alone
// returned. See Backend services/careHubService.js.
//
// The two sections have separate prefixes so Reproductive Health can be turned
// off for a customer on its own, and the backend refuses to serve a programme
// through the other section's prefix.

export const getCompanyCareDashboard = (department = '') =>
  GetApi(
    `/care-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// `programme` is one of glp-1 | pause | peptide | fibromyalgia.
export const getCompanyCareProgramme = (programme, department = '') =>
  GetApi(
    `/care-hub/programmes/${encodeURIComponent(
      programme
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

export const getCompanyReproductiveDashboard = (department = '') =>
  GetApi(
    `/reproductive-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// `programme` is one of menstrual | fertility.
export const getCompanyReproductiveProgramme = (programme, department = '') =>
  GetApi(
    `/reproductive-hub/programmes/${encodeURIComponent(
      programme
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

// ============ Trigger Hub (Company "Trigger Trace" section) ============
// What set people off, how hard it landed, and whether they got past it.
// Nothing anybody typed is reachable through these: the private notes on a
// trigger log are never read, and trigger names people wrote themselves are
// pooled server-side into one label. The users endpoint is ENGAGEMENT ONLY —
// counts and dates — and there is deliberately no per-person endpoint to go
// with it. Cohorts under the backend's minimum come back as
// { suppressed: true } with no figures. `department` narrows to one department.
export const getCompanyTriggerDashboard = (department = '') =>
  GetApi(
    `/trigger-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyTriggerPatterns = (department = '') =>
  GetApi(
    `/trigger-hub/patterns?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyTriggerResolution = (department = '') =>
  GetApi(
    `/trigger-hub/resolution?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// Counts and dates per person. No trigger, emotion, life area or intensity.
export const getCompanyTriggerUsers = ({
  page = 1,
  perPage = 10,
  search = '',
  department = ''
} = {}) =>
  GetApi(
    `/trigger-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

// ============ Games Hub (Company "Games" section) ============
// Four games — Chess, Word Search, Block Fill and You Quiz — each recording a
// different kind of play, so each is reported on its own terms rather than
// added into one meaningless total. There is NO LEADERBOARD endpoint here and
// no per-person detail endpoint: scores, win rates, ranks and levels reached
// exist only as population distributions with nobody's name attached. The users
// endpoint is engagement only and honours `Users.isUserGamePrivate`, returning
// a `hiddenCount` for anyone who opted out. Cohorts under the backend's minimum
// come back as { suppressed: true }. `department` narrows to one department.
// ===================================== Guided Path Hub =====================================
// One collection, two kinds of plan. There is no users/:id endpoint here and
// there should never be one: the only thing a detail view could add is the plan
// content itself, which is the person's own words about their life. See
// Backend services/guidedPathHubService.js.
export const getCompanyGuidedPathDashboard = (department = '') =>
  GetApi(
    `/guided-path-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// One kind of plan's own page. `planType` is ai | custom; anything else is
// rejected by the backend rather than silently returning zero.
export const getCompanyGuidedPathPlanType = (planType, department = '') =>
  GetApi(
    `/guided-path-hub/plans/${encodeURIComponent(
      planType
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

// Plans held, days active, rituals ticked and dates — no plan name, no
// description, no ritual, none of the questionnaire answers.
export const getCompanyGuidedPathUsers = ({
  page = 1,
  perPage = 10,
  search = '',
  department = ''
} = {}) =>
  GetApi(
    `/guided-path-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyGamesDashboard = (department = '') =>
  GetApi(
    `/games-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

// One game's own page. `gameKey` is one of chess | wordSearch | blockfill | quiz;
// anything else is rejected by the backend rather than silently returning zero.
export const getCompanyGameDetail = (gameKey, department = '') =>
  GetApi(
    `/games-hub/game/${encodeURIComponent(
      gameKey
    )}?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(department)}`,
    true
  );

// Plays, days played, last played and which games — no score, rank or level.
export const getCompanyGamesUsers = ({
  page = 1,
  perPage = 10,
  search = '',
  department = ''
} = {}) =>
  GetApi(
    `/games-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

// ================ MoneyMind Hub (Company "MoneyMind" section) ================
// Take-up, logging habit and the keep / unsure / let-go mix. These endpoints
// return no amount, no currency total, no income and no savings — by design.
// `department` is optional and narrows to one department when supplied.
export const getCompanyMoneyMindDashboard = (department = '') =>
  GetApi(
    `/money-mind-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyMoneyMindUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/money-mind-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyMoneyMindUserDetail = (userId) =>
  GetApi(`/money-mind-hub/users/${userId}`, true);

// ================ Elite Mind Hub (Company "Elite Mind" section) ================
// Athlete squad, journal engagement, and ONLY the reports an athlete set
// share_with_team on. Journal contents are never returned.
// `department` is optional and narrows to one squad when supplied.
export const getCompanyEliteMindDashboard = (department = '') =>
  GetApi(
    `/elite-mind-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyEliteMindUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/elite-mind-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyEliteMindUserDetail = (userId) =>
  GetApi(`/elite-mind-hub/users/${userId}`, true);

// ================ Marketplace Hub (Company "Marketplace" insights) ================
// E-Gift redemptions and VIP offer engagement for this company's people.
// `department` is optional and narrows to one department when supplied.
export const getCompanyEGiftsDashboard = (department = '') =>
  GetApi(
    `/marketplace-hub/egifts-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyVipOffersDashboard = (department = '') =>
  GetApi(
    `/marketplace-hub/vip-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyMarketplaceUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/marketplace-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyMarketplaceUserDetail = (userId) =>
  GetApi(`/marketplace-hub/users/${userId}`, true);

// ================ Challenges Hub (Company "Challenges" insights) ================
// Analytics for the challenges this company authored — participation, the
// tracked activity behind them (steps today, any tracker later) and who took
// part. Authoring stays on the admin/v1 challenge endpoints in api/index.js;
// nothing here writes. `department` is optional and narrows to one department.
export const getCompanyChallengesDashboard = (department = '') =>
  GetApi(
    `/challenges-hub/dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyChallengesList = (
  page = 1,
  perPage = 10,
  search = '',
  phase = '',
  department = ''
) =>
  GetApi(
    `/challenges-hub/challenges?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&phase=${encodeURIComponent(phase)}&department=${encodeURIComponent(
      department
    )}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyChallengesUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/challenges-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyChallengesUserDetail = (userId) =>
  GetApi(`/challenges-hub/users/${userId}?isFansMode=${getB2BFansMode()}`, true);

// ================ Perks Hub (Company "Perks" section) ================
// The four programmes the super-admin panel groups under Offerings: Instant
// Support (EAP), Salary Sacrifice, Health Scheme and the company's own Custom
// Perks. `department` is optional and narrows to one department when supplied.
//
// Availability decides which tabs exist at all — the backend also enforces it,
// returning 403 for a programme this company does not have enabled.
export const getCompanyPerksAvailability = () => GetApi('/perks-hub/availability', true);

export const getCompanyPerksOverview = (department = '') =>
  GetApi(
    `/perks-hub/overview?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyInstantSupportDashboard = (department = '') =>
  GetApi(
    `/perks-hub/instant-support-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanySalarySacrificeDashboard = (department = '') =>
  GetApi(
    `/perks-hub/salary-sacrifice-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyHealthSchemeDashboard = (department = '') =>
  GetApi(
    `/perks-hub/health-scheme-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyCustomPerksDashboard = (department = '') =>
  GetApi(
    `/perks-hub/custom-perks-dashboard?isFansMode=${getB2BFansMode()}&department=${encodeURIComponent(
      department
    )}`,
    true
  );

export const getCompanyPerksUsers = (page = 1, perPage = 10, search = '', department = '') =>
  GetApi(
    `/perks-hub/users?page=${page}&perPage=${perPage}&search=${encodeURIComponent(
      search
    )}&department=${encodeURIComponent(department)}&isFansMode=${getB2BFansMode()}`,
    true
  );

export const getCompanyPerksUserDetail = (userId) => GetApi(`/perks-hub/users/${userId}`, true);
